import { Sparkles } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Page, PageHeader } from '@/features/common/PageHeader';

export function SubscriptionScreen() {
  return (
    <Page>
      <PageHeader title="Subscription" description="Your plan and billing details." />
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>Alpha plan</CardTitle>
            <Badge variant="accent">Free</Badge>
          </div>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <p className="text-sm text-muted-foreground">
            You're on the early-access alpha plan. Everything is free during the alpha — every feature, every business, every invoice.
          </p>
          <div className="flex items-start gap-3 rounded-lg border border-line bg-secondary/40 p-4">
            <Sparkles className="size-5 text-accent" />
            <div>
              <p className="text-sm font-medium text-foreground">Paid plans coming soon</p>
              <p className="text-xs text-muted-foreground">
                When billing launches, alpha users get a generous founder discount on whichever plan fits.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </Page>
  );
}
